import { useEffect, useState } from 'react'
import classNames from 'classnames'

import Card from '../ui/Card/Card'
import MediaPlayer from '../ui/MediaPlayer/MediaPlayer'
import HeaderScrollHandler from '../HeaderScrollHandler/HeaderScrollHandler'
import useHorizontalScroll from '../../hooks/useHorizontalScroll'
import { useLanguage } from '../../context/LangaugeContextProvider/LangaugeContextProvider'

import { getImageUrl, getUrl, isArabic, isLanguage } from '../../utils'
import styles from './ProductTour.module.scss'

function ProductDetails({ details, avoidRtl }) {
  const { description: subTitle, cards = [] } = details
  const { scrollRef, scrollLeft, scrollRight, isAtStart, isAtEnd } =
    useHorizontalScroll(350, avoidRtl)
  const [selectedProduct, setSelectedProduct] = useState(cards[0])
  const { language } = useLanguage()
  const { isSpanish, isFrench } = isLanguage(language?.code)

  useEffect(() => {
    setSelectedProduct(cards[0])
  }, [cards])

  const cardClickHandler = (product) => {
    setSelectedProduct(product)
  }

  return (
    cards &&
    cards.length > 0 && (
      <div className={styles.details}>
        <div className={styles.topContainer}>
          <HeaderScrollHandler
            subTitle={subTitle}
            scrollLeft={scrollLeft}
            scrollRight={scrollRight}
            isAtEnd={isAtEnd}
            isAtStart={isAtStart}
            className={classNames('page-container', styles.scrollContainer)}
            avoidRtl={avoidRtl}
          />
          <div ref={scrollRef} className={classNames(styles.cardContainer)}>
            {cards.map((product) => (
              <Card
                key={product?.title + product?.id}
                className={classNames(styles.cardHolder, {
                  [styles.arabic_cardHolder]:
                    !avoidRtl && isArabic(language?.code),
                })}
                onClickHandler={() => {
                  cardClickHandler(product)
                }}
                style={{
                  backgroundImage: `url(${getImageUrl(product?.cardimage)})`,
                  backgroundSize: 'cover',
                }}
              >
                <div
                  className={classNames(styles.overlay, {
                    [styles.selectedCard]: product?.id === selectedProduct?.id,
                    [styles['es_overlay']]: isSpanish || isFrench,
                  })}
                >
                  <span>{product?.title}</span>
                </div>
              </Card>
            ))}
          </div>
        </div>
        {selectedProduct?.video && (
          <MediaPlayer
            src={getUrl(selectedProduct?.video || '')}
            className={classNames('page-container', styles.videoPlayer)}
            mute={true}
            preload={'auto'}
            play={true}
          />
        )}
      </div>
    )
  )
}

export default ProductDetails
